import { useTranslate } from '@tolgee/react';
import { Button } from 'antd';
import { PrivacyPolicyLink, ServiceAgreementLink } from 'components/AgreementsDocuments';
import DecorateTitle from 'components/DecorateTitle';
import { useChatttVersion } from 'hooks/business/chattt';
import { useTransAppProductName } from 'hooks/useTrans';
import { useSetUpdaterVisible } from 'hooks/useUpdater';

export const ClientVersion = (props: { canUpdate: boolean }) => {
  const { canUpdate } = props;
  const { t } = useTranslate();
  const appProductNameT = useTransAppProductName();

  const setUpdateVisible = useSetUpdaterVisible();
  const chatttVersion = useChatttVersion();
  const fettVersion = import.meta.env.VITE_VERSION!;

  return (
    <>
      <DecorateTitle>{appProductNameT('ViewSystem.system.title.chat++')}</DecorateTitle>
      <ul className="list-none p-0 flex flex-col gap-2">
        <li>
          {t('ViewSystem.当前版本')}:{chatttVersion ? `${chatttVersion} | ` : ''}
          {fettVersion ? `v${fettVersion}` : ''}
          {canUpdate && (
            <Button className="!ml-2" type="primary" onClick={() => setUpdateVisible(true)}>
              {t('ViewSystem.system.update.btn.action')}
            </Button>
          )}
        </li>
        <li>
          {t('ViewSystem.contactUs')}:<a href="mailto:contact@jolect.com">contact@jolect.com</a>
        </li>
        <li>
          <ServiceAgreementLink />
        </li>
        <li>
          <PrivacyPolicyLink />
        </li>
      </ul>
    </>
  );
};
